/** 重复登记确认文案（姓名 + 部门） */
export const OVERWRITE_CONFIRM = {
  title: '检测到已有登记',
  content:
    '系统检测到您此前已提交过申领信息。若继续提交，将覆盖原有记录，并以本次填写内容为准。是否确认继续？',
  okText: '确认继续',
  cancelText: '再想想',
};
